import { connect } from 'react-redux'
import ProductIntegration from '../../../components/products/details/product/edit/pane/ProductIntegration'
import * as actions from '../../../state/actions/provider-products/index'
import { IStoreState, IProviderProductObject } from '../../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const integration = state.integrations.items[ownProps.product.integrationId]
  return {
    integration,
    selectedIntegration: ownProps.selectedIntegration
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    saveProduct: (product: IProviderProductObject) => {
      dispatch(actions.saveProduct(product))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductIntegration)



// WEBPACK FOOTER //
// ./src/containers/products/productedit/ProductIntegration.ts